import "./testimonials.css";
import { Data } from "./Data";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Pagination } from "swiper";

function Testimonials() {
  return (
    <section className="testimonials section container">
      <h2 className="section_title">My Projects</h2>
      <span className="section_subtitle">Exercises</span>

      <Swiper
        className="testimonial_container mySwiper"
        spaceBetween={24}
        loop={true}
        grabCursor={true}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          576: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 48,
          },
        }}
        modules={[Pagination]}>
        {Data.map(({ id, image, title, source, href }) => {
          return (
            <SwiperSlide className="testimonial_card" key={id}>
              <img src={image} alt="image" className="testimonial_img" />
              <h3 className="testimonial_name">{title}</h3>
              <div className="description">
                <div className="viewCode">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    className="icon">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5"
                    />
                  </svg>

                  <a href={source} className="testimonial_description source">
                    Source Code
                  </a>
                </div>
                {href && (
                  <div className="viewCode">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="icon">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 20.25h12m-7.5-3v3m3-3v3m-10.125-3h17.25c.621 0 1.125-.504 1.125-1.125V4.875c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125z"
                      />
                    </svg>

                    <a href={href} className="testimonial_description source">
                      Live Demo
                    </a>
                  </div>
                )}
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
      <div className="more">
        More Projects on
        <a href="https://github.com/AliMoradpour"> Github.com</a>
      </div>
    </section>
  );
}

export default Testimonials;
